import React, { useState } from "react";
import { Wrapper, Content } from "./home.style";
import Section from "./Section";
import Header from "./Header";
// import Footer from "./Footer";
import { AxiosConnect } from "../AxiosConnect";
import { useEffect } from "react";

function Home() {
  const [feeds, setFeeds] = useState();
  const getFeeds = async () => {
    try {
      const { data } = await AxiosConnect.get("/v1/product/products");
      if(!data) return;
      setFeeds(data.data);
    } catch (error) {
      const msg = error.response.data.message ? error.response.data.message : error.message;
      console.warn(msg);
    }
  };


  useEffect(() => {
    getFeeds();
  }, []);


  document.title = "Axgura";

  return (
    <>
      <Header />
      <Wrapper>
        {feeds &&
          feeds.map((x) => (
            <Content>
              <Section
                title={x.name}
                desc={x.description}
                link={{ link: x.link, btntext: x.name }}
                leftbtn={x.leftbtn}
                rightbtn={x.rightbtn}
                backgroundImg={x.images}
                arrow="true"
              />
            </Content>
          ))}
      </Wrapper>
    </>
  );
}

export default Home;
